<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'加入我们'"></navBox>
			<!--导航-->
			<!--banner-->
			<div v-if="bannerList" class="banner_box">
				<van-swipe class="swipe_box" :autoplay="0" :show-indicators="false" :stop-propagation="false">
					<van-swipe-item v-for="(value, index) in type == 'social.html' ? bannerList : bannerList2" :key="index">
						<div class="swiper_el">
							<img class="bg" :src="value.imgUrl" @dragstart.prevent
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							/>
							<div class="msg_box">
								<div class="left"
									data-aos="fade-right"
									data-aos-duration="400"
									data-aos-delay="100"
									data-aos-offset="0"
									data-aos-once="true"
								>
									<div class="tit">{{ type == 'social.html' ? '社会招聘' : '校园招聘 加入库尔' }}</div>
									<div class="txt">{{ type == 'social.html' ? 'SOCIAL RECRUITMENT' : '真传帮带常态化 红包激励常态化 寻蟑找蝇常态化' }}</div>
								</div>
								<div class="right"
									data-aos="fade-right"
									data-aos-duration="400"
									data-aos-delay="100"
									data-aos-offset="0"
									data-aos-once="true"
									@click="checkType"
								>
									<div class="public_btn"><van-icon name="exchange" size="16px" class="btn_icon" /> {{ type == 'social.html' ? '校园招聘' : '社会招聘' }}</div>
								</div>
							</div>
						</div>
					</van-swipe-item>
				</van-swipe>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="top_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left">
							<img src="../../assets/img_public/job/block01.webp" />
						</div>
						<div class="right">
							<img src="../../assets/img_public/job/block02.webp" @click="goCulture" />
						</div>
					</div>
					<div class="search_box">
						<div class="search_top"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="left">
								<span class="tit">职位筛选&ensp;&ensp;&ensp;&ensp;</span>
								<span class="txt" @click="selectClear">清除条件</span>
							</div>
							<div class="right">
								<van-icon name="search" size="20px" style="top: 4px;" />
								<input v-model="inputVal" placeholder="请输入搜索关键词" />
								<div class="tit" @click="searchClick">搜索</div>
							</div>
						</div>
						<div class="search_list_box">
							<div class="search_list">
								<div v-if="addressList.length > 0" class="search_el"
									data-aos="fade-in"
									data-aos-duration="400"
									data-aos-delay="100"
									data-aos-offset="0"
									data-aos-once="true"
								>
									<div class="left">工作地点</div>
									<div class="right">
										<div :class="addressId == '' ? 'actived' : ''" @click="allClick(1)">全部</div>
										<div v-for="(value, index) in addressList" :key="index" :class="addressId == value.id ? 'actived' : ''" @click="selectCheck(1, value)">{{ value.title }}</div>
									</div>
								</div>
								<div v-if="postList.length > 0" class="search_el"
									data-aos="fade-in"
									data-aos-duration="400"
									data-aos-delay="100"
									data-aos-offset="0"
									data-aos-once="true"
								>
									<div class="left">职能类型</div>
									<div class="right">
										<div :class="postId == '' ? 'actived' : ''" @click="allClick(2)">全部</div>
										<div v-for="(value, index) in postList" :key="index" :class="postId == value.id ? 'actived' : ''" @click="selectCheck(2, value)">{{ value.title }}</div>
									</div>
								</div>
								<div v-if="leixingList.length > 0" class="search_el"
									data-aos="fade-in"
									data-aos-duration="400"
									data-aos-delay="100"
									data-aos-offset="0"
									data-aos-once="true"
								>
									<div class="left">职位性质</div>
									<div class="right">
										<div :class="leixingId == '' ? 'actived' : ''" @click="allClick(3)">全部</div>
										<div v-for="(value, index) in leixingList" :key="index" :class="leixingId == value.id ? 'actived' : ''" @click="selectCheck(3, value)">{{ value.title }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="listData.length > 0">
						<div class="list_box">
							<div class="title">全部职位</div>
							<div
								v-for="(value, index) in listData"
								:key="index"
								class="list_el"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
								@click="goInfo(value)"
							>
								<div class="tit">{{ value.title }}</div>
								<div class="bot_box">
									<div class="left">
										<van-icon name="todo-list-o" size="18px" color="#666666" style="top: 3px;" /> {{ value.post_name }} | {{ value.address_name }}
									</div>
									<div class="right">
										<van-icon name="clock-o" size="18px" color="#999999" style="top: 3px;" /> 发布时间：<span>{{ value.fabu_time }}</span>
									</div>
								</div>
							</div>
						</div>
						<div
							class="page_box"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<el-pagination
								:small="false"
								background
								layout="prev, pager, next"
								:total="total"
								:page-size="10"
								@current-change="pageChange"
							>
							</el-pagination>
						</div>
					</div>
					<div v-else>
						<van-empty image="search" description="暂无数据~" />
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import { jobSelectList, jobList } from '@/api/public';  //筛选列表
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			bannerList: [
				{ imgUrl: require('@/assets/img_public/job/banner01.webp') }
			],
			bannerList2: [
				{ imgUrl: require('@/assets/img_public/job/banner02.webp') }
			],
			type: 'social.html',
			addressList: [],
			leixingList: [],
			postList: [],
			addressId: '',
			leixingId: '',
			postId: '',
			inputVal: '',
			listData: [],
			page: 1,
			total: 0,
			listLoading: true,
		}
	},
	created(){
		let that = this;
		if(that.$route.params.jobId) {
			that.type = that.$route.params.jobId;
			//请求筛选数据
			that.getSelectList();
			//获取职位列表
			that.getList();
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		//点击进入详情
		goInfo(value) {
			let that = this;
			let routeData = that.$router.resolve({name: "JobInfo", params: { type: that.type, jobInfoId: value.id + '.html' } });
			window.open(routeData.href, '_blank');
		},
		//跳转企业文化
		goCulture() {
			this.$router.push({ path: '/about/culture.html' });
		},
		//点击搜索
		searchClick() {
			let that = this;
			that.page = 1;
			that.getList();
		},
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getList();
		},
		//请求列表
		getList() {
			let that = this;
			// that.listLoading = true;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			jobList({
				keyword: that.inputVal,
				address_id: that.addressId,
				post_id: that.postId,
				leixing_id: that.leixingId,
				leixing: that.type == 'social.html' ? 1 : 2,
				page: that.page,
				page_size: 10,
				language: sessionStorage.getItem('lang')
			}).then(res => {
				that.listData = res.data.data;
				that.total = res.data.total;
				//that.listLoading = false;
				that.$toast.clear();
			});
		},
		//清空筛选
		selectClear() {
			let that = this;
			that.addressId = '';
			that.postId = '';
			that.leixingId = '';
			that.inputVal = '';
			that.page = 1;
			that.getList();
		},
		//点击全部
		allClick(type) {
			let that = this;
			switch(type) {
				case 1:
					that.addressId = '';
				break;
				case 2:
					that.postId = '';
				break;
				case 3:
					that.leixingId = '';
				break;
			}
			that.page = 1;
			that.getList();
		},
		//切换筛选项
		selectCheck(type, value) {
			let that = this;
			switch(type) {
				case 1:
					that.addressId = value.id;
				break;
				case 2:
					that.postId = value.id;
				break;
				case 3:
					that.leixingId = value.id;
				break;
			}
			that.page = 1;
			that.getList();
		},
		//请求筛选列表
		getSelectList() {
			let that = this;
			jobSelectList({ language: sessionStorage.getItem('lang') }).then(res => {
				that.addressList = res.data.address_list;
				that.leixingList = res.data.leixing_list;
				that.postList = res.data.post_list;
			});
		},
		//切换招聘类型
		checkType() {
			let that = this;
			if(that.type == 'social.html') {
				that.$router.push({ name: 'JobList', params: { jobId: 'school.html', } });
				window.location.reload();
			}else if(that.type == 'school.html') {
				that.$router.push({ name: 'JobList', params: { jobId: 'social.html', } });
				window.location.reload();
			}
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		padding: 60px 0;
		background-color: #F7F6F9;
		.block_1_main{
			width: 1264px;
			margin: 0 auto;
			.page_box{
				padding: 30px 0 50px 0;
				text-align: center;
			}
			.list_box{
				.list_el{
					display: inline-block;
					width: 48%;
					margin: 0 1% 2% 1%;
					padding: 30px;
					background-color: #ffffff;
					border-radius: 8px;
					cursor: pointer;
					.bot_box{
						display: flex;
						padding-top: 20px;
						.left{
							flex: 1;
							font-size: 16px;
						}
						.right{
							width: auto;
							font-size: 16px;
							color: #999999;
							span{
								font-size: 17px;
								color: #999999;
							}
						}
					}
					.tit{
						padding-bottom: 8px;
						border-bottom: 1px solid #F7F6F9;
						font-size: 22px;
					}
				}
				.title{
					padding-bottom: 25px;
					font-size: 18px;
				}
			}
			.search_box{
				margin: 40px 0;
				padding: 40px 40px 30px 40px;
				border-radius: 8px;
				background-color: #ffffff;
				.search_list_box{
					padding-top: 30px;
					.search_list{
						.search_el{
							display: flex;
							margin-bottom: 5px;
							.right{
								flex: 1;
								div{
									display: inline-block;
									margin: 0 10px 10px 10px;
									padding: 6px 8px;
									border-radius: 8px;
									font-size: 16px;
									cursor: pointer;
									color: #666666;
								}
								div.actived{
									background-color: #F7F6F9;
									color: #A50073;
								}
							}
							.left{
								width: auto;
								margin-right: 20px;
								padding-top: 6px;
								font-size: 16px;
							}
						}
					}
				}
				.search_top{
					display: flex;
					align-items: center;
					.right{
						width: auto;
						position: relative;
						padding: 0 30px;
						background-color: #ffffff;
						border: 1px solid #A50073;
						border-radius: 8px;
						input{
							width: 280px;
							height: 48px;
							font-size: 16px;
							color: #A50073;
							border: none;
							padding: 0px 5px;
							user-select: none;
						}
						.tit{
							display: inline-block;
							font-size: 18px;
							cursor: pointer;
							line-height: 1;
							user-select: none;
						}
					}
					.left{
						flex: 1;
						span.txt{
							font-size: 16px;
							color: #666666;
							cursor: pointer;
						}
						span.tit{
							font-size: 24px;
							font-weight: bold;
						}
					}
				}
			}
			.top_box{
				display: flex;
				.left{
					flex: 1;
					margin-right: 12px;
					img{
						width: 100%;
					}
				}
				.right{
					flex: 1;
					margin-left: 12px;
					cursor: pointer;
					img{
						width: 100%;
					}
				}
			}
		}
	}
	.banner_box{
		min-width: 1200px;
		position: relative;
		.swipe_box{
			.swiper_el{
				position: relative;
				.msg_box{
					width: 1264px;
					margin: 0 auto;
					position: absolute;
					top: 40%;
					left: 50%;
					transform: translate(-50%, -40%);
					display: flex;
					.left{
						width: auto;
						.txt{
							padding-top: 10px;
							font-size: 18px;
							color: #ffffff;
						}
						.tit{
							font-size: 40px;
							font-weight: bold;
							color: #ffffff;
						}
					}
					.right{
						flex: 1;
						padding: 10px 0 0 30px;
						color: #ffffff;
						.public_btn{
							border: 1px solid #ffffff;
						}
					}
				}
				img.bg{
					width: 100%;
				}
			}
		}
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pager li:hover{
	color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>